<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
  provide(){
    return{
      reload:this.reload
    }
  }
}
</script>

<style>
#app{
  width: 100%;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/App.vue